import type { PayoutBatchesTranslations } from "@/shared/lang/interfaces/payoutBatches";

import type { PayoutBatchEvent } from "../types/payoutBatches.types";

export type EventActorLabelKey = Extract<
  keyof PayoutBatchesTranslations,
  "actor_system" | "actor_provider" | "actor_coloca_team" | "actor_you" | "actor_member"
>;

/**
 * Who did it, as the reader may know them. The API returns ids, not names, and hides staff ids from members
 * (`actor_user_id` comes back null with `actor_user_type: "INTERNAL"`), so a member reads "Coloca team" while
 * staff reading their own trail see themselves as "You".
 */
export function eventActorLabelKey(
  event: Pick<PayoutBatchEvent, "actor_type" | "actor_user_id" | "actor_user_type">,
  currentUserId: string | null,
): EventActorLabelKey {
  if (event.actor_type === "SYSTEM") return "actor_system";
  if (event.actor_type === "PROVIDER_WEBHOOK") return "actor_provider";
  if (event.actor_user_id && currentUserId && event.actor_user_id === currentUserId) return "actor_you";
  if (event.actor_user_type === "INTERNAL") return "actor_coloca_team";
  return "actor_member";
}
